var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "Nombre de Banco Ordenante" } },
            [
              _c("AppSelectField", {
                attrs: {
                  id: "bankName",
                  name: "bankName",
                  placeholder: "Selecciona el banco",
                  options: _vm.bankCatalog,
                  value: _vm.bankName
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePaymentBank($event)
                  },
                  change: function($event) {
                    return _vm.onChangePaymentBank($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "Cuenta Ordenante" } },
            [
              _c("BInput", {
                attrs: {
                  id: "issuingAccount",
                  name: "issuingAccount",
                  value: _vm.issuingAccount,
                  maxlength: "50",
                  pattern: _vm.accountPattern,
                  type: "string",
                  min: "0",
                  placeholder: "1234567890"
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePayment($event, "issuingAccount")
                  },
                  change: function($event) {
                    return _vm.onChangePayment($event, "issuingAccount")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC Emisor de Cuenta Ordenante" } },
            [
              _c("BInput", {
                attrs: {
                  id: "issuingRfc",
                  name: "issuingRfc",
                  value: _vm.issuingRfc,
                  "validation-message": "Rfc de la entidad bancaria",
                  maxlength: "12",
                  type: "string",
                  pattern: _vm.rfcPattern,
                  placeholder: "XAXX010101000"
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePayment($event, "issuingRfc")
                  },
                  change: function($event) {
                    return _vm.onChangePayment($event, "issuingRfc")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "Número de operación (Referencia)" } },
            [
              _c("BInput", {
                attrs: {
                  id: "operationNumber",
                  value: _vm.operationNumber,
                  maxlength: "100",
                  pattern: _vm.operationPattern,
                  type: "string",
                  placeholder: "12345ABC"
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePayment($event, "operationNumber")
                  },
                  change: function($event) {
                    return _vm.onChangePayment($event, "operationNumber")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "Cuenta Beneficiario" } },
            [
              _c("BInput", {
                attrs: {
                  name: "receiverAccount",
                  value: _vm.receiverAccount,
                  maxlength: "50",
                  pattern: _vm.accountPattern,
                  type: "string",
                  step: "0.01",
                  min: "0",
                  placeholder: "1234567890"
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePayment($event, "receiverAccount")
                  },
                  change: function($event) {
                    return _vm.onChangePayment($event, "receiverAccount")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-4 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC Emisor de Cuenta Beneficiario" } },
            [
              _c("BInput", {
                attrs: {
                  id: "receiverRfc",
                  name: "receiverRfc",
                  value: _vm.receiverRfc,
                  maxlength: "12",
                  type: "string",
                  pattern: _vm.rfcPattern,
                  placeholder: "XAXX010101000"
                },
                on: {
                  input: function($event) {
                    return _vm.onChangePayment($event, "receiverRfc")
                  },
                  change: function($event) {
                    return _vm.onChangePayment($event, "receiverRfc")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }